import { getPersistedCarProductData } from "../../carPersistence";

/**
 * Hook that reads persisted CarTrawler smartblock product data and exposes accessor methods.
 *
 * @returns {Object} Object containing accessor methods for persisted car data.
 * @returns {Function} returns.getCarInsurance - Returns insurance data from
 *   `price.payNow.insurance`, including `amount.value` and `amount.currencyCode`.
 */
export const useCarData = () => ({
  getCarInsurance: () => {
    const carInsurance = {};
    const product = getPersistedCarProductData() || {};
    const persistedInsurance = product.price?.payNow?.insurance || null;

    if (persistedInsurance && persistedInsurance.amount && persistedInsurance.amount != null) {
      carInsurance.amount = {
        currencyCode: persistedInsurance.currencyCode,
        value: parseFloat(persistedInsurance.amount),
      };
    }

    return carInsurance;
  },
});
